import { getAccessToken } from '../shared/api/token';

export async function downloadFile(url: string, filename: string) {
  const token = getAccessToken();
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  const blob = await response.blob();
  const urlObj = window.URL.createObjectURL(blob);



  const link = document.createElement('a');
  link.href = urlObj;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(urlObj);
}
